import { Slider } from "@/components/ui/slider";

export const Param = ({ label, value, min, max, step = 0.01, fmt, onChange, onCommit, testId }) => (
  <div className="space-y-2">
    <div className="flex justify-between items-baseline">
      <span className="eyebrow">{label}</span>
      <span className="font-mono-vox text-xs text-amber-300" data-testid={`${testId}-value`}>
        {fmt ? fmt(value) : value.toFixed(2)}
      </span>
    </div>
    <Slider
      data-testid={testId}
      value={[value]}
      min={min}
      max={max}
      step={step}
      onValueChange={([v]) => onChange?.(v)}
      onValueCommit={([v]) => onCommit?.(v)}
    />
  </div>
);
